<template>
  <b-modal
    id="default-reply-settings-modal"
    ref="defaultReplySettingsModal"
    modal-class="default-reply-settings-modal"
    title="Display Settings"
    hide-footer
    size="md">
    <div>
      Select time when you want to display Default Reply again to returning user.
    </div>
    <div>
      <b-form-group
        class="mt-4">
        <b-form-radio-group
          v-model="selectedPeriod"
          :options="radioOptions"
          stacked
          name="answer_periods"/>
      </b-form-group>
    </div>
    <b-button
      class="btn btn-round btn-block btn-secondary mt-5 mb-3"
      @click="messageToDelete">
      Save
    </b-button>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'DefaultReplySettingsModal',
  data() {
    return {
      replyId: false,
      selectedPeriod: 'hour',
      radioOptions: [
        { text: 'Display after 1 hour', value: 'hour' },
        { text: 'Display after 1 day', value: 'day' },
        { text: 'Display after 1 week', value: 'week' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      apiError: 'automation/apiError',
    }),
  },
  methods: {
    ...mapActions({
      deleteMessage: 'automation/deleteInstantReplyMessage',
    }),
    messageToDelete(replyId, messageId) {
      this.replyId = replyId;
      this.messageId = messageId;
    },
    isTemp(id) {
      return id.lastIndexOf('temp-', 0) === 0;
    },
    show() {
      this.$refs.defaultReplySettingsModal.show();
    },
    hide() {
      this.$refs.defaultReplySettingsModal.hide();
    },
  },
};
</script>
